<header>
    <nav class="header">
        <a [routerLink]="['']">
            <img
                src="/assets/images/svgs/musterbehoerde-logo.svg"
                class="header__logo"
                alt="Logo der Virtuellen Förderungsanstalt" />
        </a>
        <div
            *ngIf="(loggedInUser$ | async)?.loggedIn && (isMaintenance$ | async) !== true"
            class="header__user-info-area"
            data-testid="userInfoArea">
            <div
                *ngIf="userHasUnternehmenRole$ | async"
                class="header__unternehmen-drop-down">
                <app-unternehmen-selection></app-unternehmen-selection>
            </div>
            <a [routerLink]="['/postkorb']"
                ><img
                    src="/assets/images/svgs/envelope-solid.svg"
                    class="header__svg"
                    alt="Menüpunkt Postkorb"
            /></a>
            <app-user-menu [loggedInUser]="loggedInUser$ | async"></app-user-menu>
        </div>
    </nav>
</header>
